import { QuantidadePorMesLinha } from '@core/services/vendas.interface';
import { LinhaVenda } from '@shared/models/linha-venda.interface';

export class VerificaPrevisaoCompletaService{
  constructor(
    private anoMesDisponiveisPrevisao: number[],
    private linhasVendas: LinhaVenda[],
  ){
  }

  private getIdLinhaProduto(linhas: string){
    return linhas == "1, 3, 7, 8" ? 3 : 2
  }

  private verificaSeExistePrevisaoParaLinha(quantidadePorMesLinha: QuantidadePorMesLinha[], linhas: string, anoMes: number){
    const existePrevisaoParaLinha = quantidadePorMesLinha.some(
      previsao => {
        return linhas == previsao.linhas &&
        anoMes == previsao.anoMes
      }
    )

    return existePrevisaoParaLinha;
  }

  private verificaPrevisaoCompletaLinhasVendas(anoMes: number, linhasVendas: LinhaVenda[], quantidadePorMesLinha: QuantidadePorMesLinha[]){
    const previsaoIncompletaParaLinha = linhasVendas.some(
      linha => {
        const existePrevisaoParaLinha = this.verificaSeExistePrevisaoParaLinha(quantidadePorMesLinha, linha.linhas, anoMes)

        return !existePrevisaoParaLinha;
      }
    )

    return previsaoIncompletaParaLinha;
  }

  private verificaPrevisaoCompletaAnoMesDisponiveisPrevisao(anoMesDisponiveisPrevisao: number[], linhasVendas: LinhaVenda[], quantidadePorMesLinha: QuantidadePorMesLinha[]){
    const previsaoIncompleta = anoMesDisponiveisPrevisao.some(anoMes => {
      const previsaoIncompletaParaLinha = this.verificaPrevisaoCompletaLinhasVendas(anoMes, linhasVendas, quantidadePorMesLinha)
      return previsaoIncompletaParaLinha;
    })

    return previsaoIncompleta;
  }

  execute(quantidadePorMesLinha: QuantidadePorMesLinha[]){
    const previsaoIncompleta = this.verificaPrevisaoCompletaAnoMesDisponiveisPrevisao(
      this.anoMesDisponiveisPrevisao,
      this.linhasVendas,
      quantidadePorMesLinha
    )

    return !previsaoIncompleta;
  }
}
